// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"buttonWrapper--2o5Do"};